
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionType } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';

import { IConfirmModalContent } from '../../models';

// TODO: Migrate first

@Component({
	selector: 'confirm-modal',
	templateUrl: './confirm-modal.component.html',
	imports: [TranslateModule]
})
export class ConfirmModalComponent {
	activeModal = inject(NgbActiveModal);


	@Input() contentConfig: IConfirmModalContent;

	actionTypes = ActionType;
}
